import React, { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import Carousel from './Carousel';
import { getBrandProduct } from '../../../redux/actions/product';
import ProductMiniature from '../../../commons/ProductMiniature';

class FeaturedBrand extends Component {
  constructor() {
    super();

    this.state = {
      products: [],
      loading: false
    };
  }

  componentDidMount() {
    this.props.getBrandProduct(this.props.brand.id);
  }

  componentDidUpdate(prevProps) {
    if (!lodash.isEqual(prevProps.brandProducts, this.props.brandProducts)) {
      const BRAND_ID = this.props.brand.id;
      if (
        !this.state.loading &&
        this.props.brandProducts[BRAND_ID] &&
        this.props.brandProducts[BRAND_ID].requesting
      ) {
        this.setState({ loading: true });
      }
      if (
        this.state.loading &&
        this.props.brandProducts[BRAND_ID] &&
        !this.props.brandProducts[BRAND_ID].requesting
      ) {
        this.setState(
          {
            loading: false,
            products: this.props.brandProducts[BRAND_ID].products
          },
          this.props.onFinishLoading
        );
      }
    }
  }

  render() {
    return (
      <Carousel
        carouselHeader={`LO NUEVO DE ${this.props.brand.name.toUpperCase()}`}
        carouselLink={`/productos/marca/${this.props.brand.id}`}
        loading={this.state.loading || this.props.loadingOtherBrands}
        noPlaceholder
      >
        {this.state.products.map(product => (
          <ProductMiniature key={product.id} product={product} />
        ))}
      </Carousel>
    );
  }
}

const mapStateToProps = state => ({
  status: state.product.status,
  brandProducts: state.product.brandProducts
});

const mapDispatchToProps = dispatch => ({
  getBrandProduct: brand => dispatch(getBrandProduct(brand))
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedBrand);
